// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format17 } from '../../constants';

/** Falkland Islands (Islas Malvinas) */
const FK: PhoneNumberData = [500, 'FK', 5, format17];

export default FK;
